import { getCloudUrl } from '@/utils/cloud';
import { debounce } from 'es-toolkit';
import { VideoOff } from 'lucide-react';
import { useCallback, useRef } from 'react';
export const VodPreview = ({
  src,
  height,
  width,
  activityId
}: {
  src?: string;
  height: number;
  width: number;
  activityId: string;
}) => {
  const ref = useRef<HTMLVideoElement>(null);
  const onLoadedData = () => {
    if (ref.current) {
      ref.current.currentTime = Math.max(0, ref.current.duration - 60);
    }
  };

  // There are quite a few weird issues with these:
  // the biggest one is a chrome error that happens when play is called during a call to pause and v-v
  // const onMouseEnter = useCallback(() => {
  //   if (ref.current && ref.current.paused) {
  //     try {
  //       ref.current.play();
  //     } catch {}
  //   }
  // }, []);

  // const onMouseLeave = useCallback(() => {
  //   if (ref.current && !ref.current.paused) {
  //     try {
  //       ref.current.pause();
  //     } catch {}
  //   }
  // }, []);

  // eslint-disable-next-line react-hooks/refs
  const debouncedJogger = debounce((pct: number) => {
    if (ref.current && !isNaN(pct) && !isNaN(ref.current.duration)) {
      ref.current.currentTime = pct * ref.current.duration;
    }
  }, 300);
  const onMouseOver = useCallback((evt: React.MouseEvent<HTMLVideoElement>) => {
    if (ref.current) {
      const pct_0 = (evt.clientX - ref.current.getBoundingClientRect().left) / ref.current.width;
      debouncedJogger(pct_0);
    }
  }, [debouncedJogger]);
  return <div style={{
    width: width,
    height: height
  }} className="relative">
      <video ref={ref} src={src ? `vod://vods/${btoa(src)}` : getCloudUrl(activityId)} height={height} width={width} style={{
      objectFit: 'contain',
      zIndex: 11,
      position: 'absolute',
      top: 0,
      left: 0
    }} onLoadedData={onLoadedData}
    // onMouseEnter={onMouseEnter}
    // onMouseLeave={onMouseLeave}
    onMouseMove={onMouseOver} muted />
      <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
        <VideoOff size={height * 0.5} className="text-gray-500" />
      </div>
    </div>;
};